import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { findIndex, slice } from "lodash";
import { SLIDE_NUMBER } from "../constants";

const [weekFrequency] = [7];

export async function getDefaultCalendarSelection(
  commodities: number[],
  calendarOriginItems: DictionaryItem[],
  dictionariesService: DictionariesService,
) {
  const lastCalendarDictionary = await dictionariesService.getDictionary({
    id: "slides-f-last-calendar",
    parameters: {
      commodities: commodities ? String(commodities.join(",")) : "120,12,13,18",
      slide: SLIDE_NUMBER,
    },
  });

  const lastCalendarItems = await lastCalendarDictionary.getAll();
  const sortedCalendarItems = calendarOriginItems.sort((a, b) => Number(a.id) - Number(b.id));

  const currentDate = new Date();
  const defaultLastMonthMark = Number(
    `${weekFrequency}${currentDate.getFullYear()}${currentDate.getMonth()}${currentDate.getDay()}`,
  );
  let calendarMark;

  if (lastCalendarItems.length > 0) {
    const lastCalendarMark = Number(lastCalendarItems[0].id);
    const lastCalendarMarkIdx = findIndex(
      sortedCalendarItems,
      (item) => item.getValue<number>("id") === lastCalendarMark,
    );

    const halfYearWeeks = 24;
    const lastHalfYearMonths = slice(
      sortedCalendarItems,
      lastCalendarMarkIdx - halfYearWeeks - 1,
      lastCalendarMarkIdx + 1,
    );

    calendarMark = lastHalfYearMonths.map((item) => Number(item.id));
  } else {
    calendarMark = [defaultLastMonthMark];
  }

  return {
    calendar: calendarMark,
  };
}
